import React from 'react'
import {  Card, DatePicker,Button } from 'antd';
import {SendOutlined} from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';

class HeaderTitle extends React.Component{
    render(){
        let {momen, onChangeDate, onProcess} = this.props
        return (
            <Col sm={12}  lg={12} style={{marginBottom:20}}>
                <Card bordered={false} className="box">
                    <Row>
                        <Col sm={8}  lg={8} style={{textAlign:"right"}}>
                            Periode  Transaksi
                        </Col>
                        <Col sm={2}  lg={2} style={{textAlign:"left"}}>
                            <DatePicker style={{width : '100%', maxWidth: '300px'}} onChange={onChangeDate} picker="month" defaultValue={momen}  />  
                        </Col>
                        <Col sm={1}  lg={1} style={{textAlign:"right"}}>
                            <Button className="primaryButton" icon={<SendOutlined />} onClick={onProcess} >
                                Process
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </Col>
        )
    }
}

export default HeaderTitle